/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourceOnboardStatusInfo } from './resourceOnboardStatusInfo';


export interface ResourcesOnboardStatus { 
    resources_failed_to_onboard?: Array<ResourceOnboardStatusInfo>;
    resources_successfully_onboarded?: Array<ResourceOnboardStatusInfo>;
}

